module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-500.e69152b4.woff";